// 能源畫面的 mock 開關（WP-6 app-api 能源 API 還沒上 dev 之前看畫面用；做法同 features/kmgr/mockMode.ts）。
//
// 只在 dev / test（hasDevFeatures）才可能打開；prod 一律關。打開的方式（先到先用）：
//   1. 瀏覽器 localStorage `vms.energy.mock` = `off`（關）/ `missing`（只 mock 還沒有的端點）/ `all`（全部 mock）
//   2. 品牌 / plane 設定 features.energy_mock = true → `missing`
//   3. 都沒有 → 關（直接打 app-api；端點不在時顯示「讀不到用電資料」）
// 還沒有的端點清單見 api.ts 的 MISSING_ENDPOINTS；WP-6 上一個拿掉一個，畫面不用改。
import { hasDevFeatures, type AppConfig } from '../../lib/appConfig';

export type EnergyMockMode = 'off' | 'missing' | 'all';

export const ENERGY_MOCK_KEY = 'vms.energy.mock';

export function energyMockMode(cfg: Pick<AppConfig, 'env' | 'features'>, stored: string | null = readStored()): EnergyMockMode {
  if (!hasDevFeatures(cfg.env)) return 'off';
  if (stored === 'off' || stored === 'missing' || stored === 'all') return stored;
  return cfg.features?.energy_mock === true ? 'missing' : 'off';
}

function readStored(): string | null {
  try {
    return localStorage.getItem(ENERGY_MOCK_KEY);
  } catch {
    return null;
  }
}
